import { WA_WINDOW } from '@ng-web-apis/common';
import { inject, Injectable } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { map, Observable } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root',
})
export class DeviceDetectorService {
  private readonly breakpointObserver = inject(BreakpointObserver);
  private readonly window = inject(WA_WINDOW);
  private readonly maxWidth = '(max-width: 47.9625em)';

  get isDesktop$(): Observable<boolean> {
    return this.breakpointObserver
      .observe([this.maxWidth])
      .pipe(map(result => !result.matches));
  }

  get isMobile$(): Observable<boolean> {
    return this.breakpointObserver
      .observe([this.maxWidth])
      .pipe(map(result => result.matches));
  }

  readonly $isDesktop = toSignal(
    this.breakpointObserver
      .observe([this.maxWidth])
      .pipe(map(result => !result.matches)),
    { initialValue: false },
  );

  readonly $isMobile = toSignal(
    this.breakpointObserver
      .observe([this.maxWidth])
      .pipe(map(result => result.matches)),
    { initialValue: false },
  );

  get isIOS(): boolean {
    if (typeof this.window.navigator === 'undefined' || !navigator.userAgent) {
      return false;
    }

    return (
      /iPad|iPhone|iPod/.test(navigator.userAgent) &&
      !(this.window.navigator as any).MSStream
    );
  }

  get isChromiumBased(): boolean {
    if (typeof this.window.navigator === 'undefined' || !navigator.userAgent) {
      return false;
    }
    const ua = this.window.navigator.userAgent;

    return (
      /(Chrome|Chromium|Edg)\//.test(ua) &&
      !/OPR\//.test(ua) && // Exclude Opera
      !/Edge\//.test(ua) // Exclude old Edge
    );
  }

  get isInPwaMode(): boolean {
    // For most browsers
    if (this.window.matchMedia('(display-mode: standalone)').matches) {
      return true;
    }

    // For iOS Safari
    if ((this.window.navigator as any).standalone) {
      return true;
    }

    return false;
  }
}
